import {
	SET_HOME_TRENDS, SET_PARK_TRENDS, SET_SELECTED_ASSETS, SHOW_TOAST, SET, RESET_STATE
} from "./TrendAssetsActionType";

const mutations = {
	[SET]: (state, assets) =>
	{
		state.assets = assets;
	},
	[SET_SELECTED_ASSETS]: (state, selectedAssets) =>
	{
		state.selectedAssets = selectedAssets;
	},
	[SET_HOME_TRENDS](state, value)
	{
		state.isHomeTrends = value;
	},
	[SET_PARK_TRENDS](state, value)
	{
		state.isParkTrends = value;
	},
	[SHOW_TOAST](state, { message, type })
	{
		state.showToast = true;
		state.toastMessage = message;
		state.toastType = type;
	},
	[RESET_STATE](state)
	{
		state.selectedAssets = [];
		state.assets = [];
		state.isHomeTrends = false;
		state.isParkTrends = false;
		state.showToast = false;
		state.toastMessage = "";
		state.toastType = "";
	},
};

export default { mutations };
